import { Constants, PERFORMANCE_BONUS_SCHEDULE_ANZ, PERFORMANCE_BONUS_SCHEDULE_EU } from '@models/Constants'
import { Country } from '@models/Country'
import { Locale } from '@models/Language'
import { Store } from '@stores/Store'

export class CountryHelper {
  store!: Store

  constructor(store: Store) {
    this.store = store
  }

  get selectedUA(): boolean {
    const { country } = this.store.globalStore
    return country === Country.UA
  }

  get selectedANZ(): boolean {
    const { country } = this.store.globalStore
    return country === Country.AU || country === Country.NZ
  }

  get selectedUKANZ(): boolean {
    const { country } = this.store.globalStore
    return country === Country.AU || country === Country.NZ || country === Country.GB
  }

  get selectedLanguageZH(): boolean {
    const { locale } = this.store.globalStore
    return locale === Locale.ZH
  }

  get qmonthGroupPVFrontlines(): number {
    if (this.selectedANZ) {
      return Constants.QMONTH_GROUP_PV_MORE_THAN_ONE_FRONTLINES_ANZ
    }

    return Constants.QMONTH_GROUP_PV_MORE_THAN_ONE_FRONTLINES_EU
  }

  get qmonthGroupPVFrontline(): number {
    if (this.selectedANZ) {
      return Constants.QMONTH_GROUP_PV_ONE_FRONTLINE_ANZ
    }

    return Constants.QMONTH_GROUP_PV_ONE_FRONTLINE_EU
  }

  get performanceBonusSchedule(): [number, number][] {
    if (this.selectedANZ) {
      return PERFORMANCE_BONUS_SCHEDULE_ANZ
    }

    return PERFORMANCE_BONUS_SCHEDULE_EU
  }

  get retailMarginPercent(): number {
    if (this.selectedUA) { return 0 }
    if (this.store.globalStore.country === Country.ZA) { return Constants.RETAIL_MARGIN_PERCENT_ZA }

    return Constants.RETAIL_MARGIN_PERCENT
  }

  get rubyBonus(): number {
    const rubyBonusPVMinimum = this.selectedANZ ? Constants.RUBY_BONUS_PV_MINIMUM_ANZ : Constants.RUBY_BONUS_PV_MINIMUM_EU
    const { rubyPV, rubyBV } = this.store
    if (rubyPV > rubyBonusPVMinimum) {
      return rubyBV * Constants.RUBY_BONUS_PERCENT
    }

    return 0
  }


  // Bronze Incentive

  get bronzeFoundationEligible(): boolean {
    const { bronzeIncentiveCalculation, bronzeIncentivesStore, personalPV } = this.store
    const { bronzeActualPPV } = bronzeIncentiveCalculation
    const { bronzeFoundationEnabled } = bronzeIncentivesStore

    if (this.selectedANZ) {
      return (bronzeActualPPV >= Constants.BRONZE_ELIGIBLE_VALUE && personalPV >= Constants.BRONZE_MIN_PERSONAL_PV) ? bronzeFoundationEnabled : false
    }

    return bronzeActualPPV >= Constants.BRONZE_ELIGIBLE_VALUE ? bronzeFoundationEnabled : false
  }

  get bronzeBuilderEligible(): boolean {
    const { bronzeIncentiveCalculation, bronzeIncentivesStore, personalPV } = this.store
    const { bronzeActualPPV } = bronzeIncentiveCalculation
    const { bronzeBuilderEnabled } = bronzeIncentivesStore

    if (this.selectedANZ) {
      return (bronzeActualPPV >= Constants.BRONZE_ELIGIBLE_VALUE && personalPV >= Constants.BRONZE_MIN_PERSONAL_PV) ? bronzeBuilderEnabled : false
    }

    return bronzeActualPPV >= Constants.BRONZE_ELIGIBLE_VALUE ? bronzeBuilderEnabled : false
  }


  // Decimal Separator Format

  get decimalSeparatorFormat(): string {
    if (this.selectedUKANZ) {
      return '.'
    }

    return ','
  }

}
